<template>
  <div>
    <ListDisplay
      :show-icon="showTooltip"
      icon-name="EF0080"
      :title="title"
      :button-icon-label="tooltipLabel"
      @click="handleTooltipClick"
    />
    <Heading :level="3" :style="{ color: getCurrencyTextColor(value.value) }">{{
      value.formatted
    }}</Heading>
  </div>
</template>

<script lang="ts" setup>
import { ListDisplay, Heading } from '@warrenbrasil/nebraska-web';

import { getCurrencyTextColor } from '@/modules/common/helpers/currency';
import { NumberFormatted } from '@/modules/trade/types';

interface Props {
  title: string;
  value: NumberFormatted;
  showTooltip?: boolean;
  tooltipLabel?: string;
}
defineProps<Props>();

interface Emits {
  (e: 'tooltip-click'): void;
}
const emit = defineEmits<Emits>();

const handleTooltipClick = () => {
  emit('tooltip-click');
};
</script>
<style lang="less" scoped></style>
